// extracted by mini-css-extract-plugin
export var center = "_4e-2";
export var clickableRow = "_4e-5";
export var expandedRow = "_4e-7";
export var hoverable = "_4e-4";
export var left = "_4e-1";
export var right = "_4e-3";
export var row = "_4e-0";
export var selectedRow = "_4e-6";